document.documentElement.classList.remove('no-js');

const menu = document.querySelector('#cbw-menu');
const menuToggle = document.querySelector('.cbw-menu-toggle');
const menuClose = document.querySelector('.cbw-menu-close');

if (menu && menuToggle) {
  menuToggle.addEventListener('click', () => {
    menu.showModal();
    menuToggle.setAttribute('aria-expanded', 'true');
  });
  menuClose?.addEventListener('click', () => {
    menu.close();
    menuToggle.setAttribute('aria-expanded', 'false');
  });
  menu.addEventListener('click', event => {
    if (event.target === menu) menuClose?.click();
  });
}

document.querySelectorAll('[data-product-root]').forEach(root => {
  const variantInput = root.querySelector('[data-variant-input]');
  const quantityInput = root.querySelector('[data-quantity-input]');
  const price = root.querySelector('[data-product-price]');
  const comparePrice = root.querySelector('[data-product-compare-price]');
  const savings = root.querySelector('[data-product-save]');
  const mainImage = root.querySelector('[data-product-main-image]');
  const addButton = root.querySelector('.cbw-add-button');
  const addLabel = root.querySelector('[data-add-label]');
  const message = root.querySelector('[data-form-message]');
  const variantsNode = root.querySelector('[data-product-variants]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];

  const syncVariant = () => {
    const selectedOptions = Array.from(root.querySelectorAll('[data-product-option]')).map(group => group.querySelector('[data-option-value]:checked')?.value);
    const variant = selectedOptions.length ? variants.find(item => item.options.every((option, index) => option === selectedOptions[index])) : variants[0];

    if (!variant) {
      variantInput.value = '';
      variantInput.removeAttribute('value');
      addButton.disabled = true;
      addLabel.textContent = root.dataset.unavailableText;
      return null;
    }

    variantInput.value = variant.id;
    variantInput.setAttribute('value', variant.id);
    quantityInput.value = '1';
    quantityInput.setAttribute('value', '1');
    price.textContent = variant.price;
    if (comparePrice) {
      comparePrice.textContent = variant.comparePrice || '';
      comparePrice.hidden = !variant.comparePrice;
    }
    if (savings) {
      savings.textContent = variant.savings ? `${root.dataset.saveText} ${variant.savings}` : '';
      savings.hidden = !variant.savings;
    }
    addButton.disabled = !variant.available;
    addLabel.textContent = variant.available ? root.dataset.addText : root.dataset.soldOutText;

    if (variant.image && mainImage) {
      mainImage.src = variant.image;
      mainImage.removeAttribute('srcset');
      root.querySelectorAll('[data-media-src]').forEach(item => item.classList.toggle('is-active', item.dataset.mediaSrc === variant.image));
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
    return variant;
  };

  root.querySelectorAll('[data-option-value]').forEach(input => input.addEventListener('change', syncVariant));
  syncVariant();

  root.querySelectorAll('[data-media-src]').forEach(button => {
    button.addEventListener('click', () => {
      root.querySelectorAll('[data-media-src]').forEach(item => item.classList.remove('is-active'));
      button.classList.add('is-active');
      if (mainImage) {
        mainImage.src = button.dataset.mediaSrc;
        mainImage.alt = button.dataset.mediaAlt || '';
      }
    });
  });

  const description = root.querySelector('[data-description-copy]');
  const descriptionToggle = root.querySelector('[data-description-toggle]');
  descriptionToggle?.addEventListener('click', () => {
    const expanded = descriptionToggle.getAttribute('aria-expanded') === 'true';
    descriptionToggle.setAttribute('aria-expanded', String(!expanded));
    description?.classList.toggle('is-expanded', !expanded);
    descriptionToggle.querySelector('[data-description-more]').hidden = !expanded;
    descriptionToggle.querySelector('[data-description-less]').hidden = expanded;
  });

  root.querySelector('form')?.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = syncVariant();
    if (!variant || !variant.available) return;
    addButton.disabled = true;
    addLabel.textContent = root.dataset.addingText;
    message.textContent = '';
    try {
      const payload = new FormData();
      payload.set('id', variant.id);
      payload.set('quantity', '1');
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await fetch('/cart.js').then(item => item.json());
      document.querySelectorAll('[data-cart-count]').forEach(item => { item.textContent = cart.item_count; });
      addLabel.textContent = root.dataset.addedText;
      window.setTimeout(() => { window.location.href = '/cart'; }, 450);
    } catch (error) {
      message.textContent = root.dataset.errorText;
      addButton.disabled = false;
      addLabel.textContent = root.dataset.addText;
    }
  });
});

document.querySelectorAll('.cbw-testimonials').forEach(section => {
  const track = section.querySelector('[data-slider]');
  section.querySelector('[data-slider-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.82, behavior: 'smooth' }));
  section.querySelector('[data-slider-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.82, behavior: 'smooth' }));
  const dots = Array.from(section.querySelectorAll('.cbw-slider-dots i'));
  track?.addEventListener('scroll', () => {
    const card = track.querySelector('.cbw-testimonial');
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const index = card ? Math.round(track.scrollLeft / (card.getBoundingClientRect().width + gap)) : 0;
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
  }, { passive: true });
});
